import React, { useRef, useState, useContext, useEffect } from "react";
import "./style.css"
import { Button, Modal, ModalContent, ModalOverlay, Spinner } from "@chakra-ui/react";
import { AddIcon, CircledCheckIcon } from "../../Assets/images/svgs";
import { CounterInput, HeaderWallet, PopUpModal, Select, Switcher, Title } from "../../Components/Atoms";
import { StoreContext } from "../../Library/contexts";
import { LastOrder } from "../../Widgets"
import { OrdersTable } from "../../Components/Organisms";
import { getAllDealers, getOrderDetails, getShipmentDetails, placeOrder } from "../../APIs";
import { getLocalisedNumber } from "../../Library/helpers";
import { useLocation, useNavigate } from "react-router-dom";
import { DEVICE_TYPES, DEVICE_TYPES_VALS, SELLER_DES, SUBDEALERS_DES, VENDORS, DEV_TYPE_VALUES, DEV_TYPES } from "../../Library/constants";
import PATHS from "../../Routes/paths";
import Loader from "../Loader";

const OrdersOverview = () => {
  const [ showNewOrderModal, setShowNewOrderModal ] = useState(false);
  const [ dealers, setDealers ] = useState([]);
  const [ selectedDealer, setSelectedDealer ] = useState(0);
  const [ selectedVendor, setSelectedVendor ] = useState(0);
  const [ selectedDeviceType, setSelectedDeviceType ] = useState(0);
  const [ deviceQuantity, setDeviceQuantity ] = useState(1);
  const [ orderAmount, setOrderAmount ] = useState(0);
  const [ orderFormError, setOrderFormError ] = useState("");
  const [ showSuccessModal, setShowSuccessModal ] = useState(false);
  const [ selectedPage, setSelectedPage ] = useState(1);
  const dealersMap = useRef({});
  const navigate = useNavigate();
  const location = useLocation();
  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
  const [ordersData, setOrdersData] = useState({});

  useEffect(() => {
    let fetchFunc = DESIGNATION === SELLER_DES ? getOrderDetails : getShipmentDetails;

    fetchFunc(null, null, null, (err, allOrders) => {
      if (err) console.error(err);
      else setOrdersData(allOrders);
    });
  }, [ DESIGNATION ]);

  const handleMenuClick = () => {
    if (!dealers || !dealers.length) {
      getAllDealers(null, (err, data) => {
        if (err) console.error(err);
        else {
          data.forEach(dealer => {
            dealersMap.current[dealer.idx] = dealer;

            dealer.label = dealer.nm;
            dealer.value = dealer.idx;
          });

          setDealers(data)
        };
      });
    }
  }

  const handleQuantityAndAmountChange = (count, dev) => {
    if (dev || selectedDeviceType) {
      let amount = DEVICE_TYPES_VALS[dev || selectedDeviceType].price * count;
      if (amount && Number(amount)) amount = getLocalisedNumber(amount);
      else amount = 0;

      setOrderAmount(amount);
    }

    setDeviceQuantity(count);
  }

  const handleDeviceTypeChange = (dev) => {
    setOrderFormError("");
    setSelectedDeviceType(dev);
    handleQuantityAndAmountChange(deviceQuantity, dev);
  }

  const placeNewOrder = () => {
    let errMsg = "";
    // if (!selectedDealer) errMsg = "Please select dealer";
    if (!selectedVendor) errMsg = "Please select vendor";
    if (!selectedDeviceType) errMsg = "Please select device type";

    if (errMsg) return setOrderFormError(errMsg);

    let orderData = {
      devcnt: deviceQuantity,
      hwtyp: 3,
      batTyp: selectedDeviceType,
      vdrId: selectedVendor,
      // dlrId: selectedDealer,
    }

    // let dealerDetails = dealersMap.current[selectedDealer];
    // if (dealerDetails) {
    //   if (dealerDetails.nm) orderData.dnm = dealerDetails.nm;
    //   if (dealerDetails.st) orderData.st = dealerDetails.st;
    //   if (dealerDetails.ct) orderData.ct = dealerDetails.ct;
    // }

    placeOrder(orderData, (err, success) => {
      if (err) setOrderFormError(err);
      else {
        if (success.orderId) {
          setShowNewOrderModal(false);
          setShowSuccessModal(true);

          setTimeout(() => {
            if (success.orderId) {
              let isDashboard = location.pathname.includes(PATHS.DEALERS_OVERVIEW);
              let path = `${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?idx=${success.orderId}`;
              if (isDashboard) path = `${PATHS.DEALERS_OVERVIEW}${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?idx=${success.orderId}`;
              navigate(path);
            } else setShowSuccessModal(false);
          }, 2000);
        } else setOrderFormError("Something went wrong! Please try again later.");
      }
    });
  }

  const getSuccessModalBody = () => {
    return (
      <div className="order-placed-modal-msg">
        <CircledCheckIcon />
        <p>Order Placed</p>
      </div>
    )
  }

  const PAGE_SWITCHER_OPTIONS = [
    { idx: 1, label: "All Orders", path: `${PATHS.DEALERS_OVERVIEW}${PATHS.ORDERS_OVERVIEW}` },
    { idx: 2, label: "History", path: `${PATHS.DEALERS_OVERVIEW}/${PATHS.TRANSACTION_DETAILS}` },
  ]

  const handlePageSwitch = (tab) => {
    setSelectedPage(tab.idx);
    navigate(tab.path);
  }

  return (
    <>
      {ordersData && ordersData.orders ? <section className="panel-main orders-overview">
        <header className="place-new-order-header">
          <HeaderWallet />
          {DESIGNATION === SELLER_DES ? <Button onClick={() => setShowNewOrderModal(true)} className="place-new-order-btn">
            <AddIcon className="new-order-icon" />
            Place New Order
          </Button> : null }
        </header>
        {DESIGNATION === SELLER_DES && <Switcher
          className="orders-page-switcher"
          options={PAGE_SWITCHER_OPTIONS}
          selectedOption={selectedPage}
          handleChange={handlePageSwitch}
        />}
        <article className="recent-order-status">
          <Title variant="md" fixed>{DESIGNATION === SELLER_DES ? "Recent Order Status" : "Recent Shipment Status"}</Title>
          {ordersData.orders ? <LastOrder recentOrderData={DESIGNATION === SELLER_DES ? ordersData : {}} shipmentData={DESIGNATION === SELLER_DES ? {} : ordersData} showOrderDetails={false} isOverviewPage={true} isShipmentTimeLine={DESIGNATION === SUBDEALERS_DES} isShipmentOverviewPage={DESIGNATION === SUBDEALERS_DES} /> : null}
        </article>

        {ordersData.orders ? <OrdersTable allOrdersData={DESIGNATION === SELLER_DES ? ordersData : {}} shipmentData={DESIGNATION === SELLER_DES ? {} : ordersData} hideDealerNames={DESIGNATION === SUBDEALERS_DES} shipment={DESIGNATION === SUBDEALERS_DES} /> : null}

        <Modal size={"4xl"} isOpen={showNewOrderModal} onClose={() => setShowNewOrderModal(false)}  isCentered={true}>
          <ModalOverlay />

          <ModalContent className="place-new-order-modal" >
            <Title variant="md" fixed>Place New Order</Title>
            <div className="place-new-order-form">
              {/* <Select menuButtonClick={handleMenuClick} selected={selectedDealer} defaultOption="Select Dealer" onChange={(dlr) => { setSelectedDealer(dlr); setOrderFormError(""); }} options={dealers} width={"100%"} menuButtonClass={`new-order-dropdown ${selectedDealer ? "selected" : ""}`} menuListClass="new-order-dropdown-list" /> */}
              <Select selected={selectedVendor} defaultOption="Select Device Vendor" onChange={(vndr) => { setSelectedVendor(vndr); setOrderFormError(""); }} options={VENDORS} width={"100%"} menuButtonClass={`new-order-dropdown ${selectedVendor ? "selected" : ""}`} menuListClass="new-order-dropdown-list" />
              <Select selected={selectedDeviceType} defaultOption="Select Device Type" onChange={handleDeviceTypeChange} options={DEVICE_TYPES} width={"100%"} menuButtonClass={`new-order-dropdown ${selectedDeviceType ? "selected" : ""}`} menuListClass="new-order-dropdown-list" />
              <div className="quantity-and-amount-container">
                <CounterInput
                  labelClassName="device-quantity-counter"
                  label={"Enter Device Quantity"}
                  counterContainer="counter-input"
                  counterButton="counter-button"
                  counterDisplay="counter-display"
                  defaultValue={0}
                  onChange={handleQuantityAndAmountChange}
                  minValue={1}
                  // showAmount={orderAmount}
                />
              </div>

              <div className="new-order-form-btns">
                <p className="new-order-form-err">{orderFormError}</p>
                <div className="new-order-form-btns-container">
                  <Button className="cancel-new-order-btn" onClick={() => setShowNewOrderModal(false)}>
                    Cancel
                  </Button>
                  <Button className="place-order-btn" onClick={placeNewOrder}>
                    Place Order
                  </Button>
                </div>
              </div>
            </div>
          </ModalContent>
        </Modal>

        <PopUpModal open={showSuccessModal} modalMsg={getSuccessModalBody()} darken onModalClose={() => {}}/>
      </section> :  <Loader hide={true}/>}
    </>
  )
}

export default OrdersOverview